export const DisplayDateFormat = 'DD.MM.YYYY.';
export const DisplayDateTimeFormat = 'DD.MM.YYYY. HH:mm:ss';
export const DateTimeNoSecFormat = 'DD.MM.YYYY. HH:mm';
export const DefaultDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
export const DefaultDateFormat = 'YYYY-MM-DD';
export const TimeNoSecFormat = 'HH:mm';
export const JavaFormat = 'YYYY-MM-DDTHH:mm:ss[Z]';
export const DisplayDateMonthFormat = 'MMMM YYYY.';
export const DisplayYearFormat = "YYYY."